import { axios } from "./http.js";

export const addMsg = params => {
  return axios.post("/msg/", params);
};
export const getMsgList = params =>
  axios.get(`/msg/list/${params.pageNo}/${params.pageSize}`, params);

export const getMsg = id => axios.get(`/msg/list/${id}`);
